import { createContext } from 'react';

export const defaultCt = {
    map: null as any,
}
export const Map4dContext = createContext(defaultCt)